import React, { useEffect, useState } from "react";  // ✅ FIXED
import { useNavigate } from "react-router-dom";
import { db } from "../firebase";
import { collection, getDocs, deleteDoc, doc } from "firebase/firestore";
import AdminPostJob from "./AdminPostJob";
import AdminApplicants from "./AdminApplicants"; 
import "./AdminDashboard.css";

function AdminDashboard() {
  const navigate = useNavigate();
  const [activePage, setActivePage] = useState("dashboard");
  const [messages, setMessages] = useState([]);
  const [applications, setApplications] = useState([]);

  const handleLogout = () => {
    localStorage.removeItem("admin");
    navigate("/admin");
  };

  const fetchMessages = async () => {
    const querySnapshot = await getDocs(collection(db, "contacts"));
    const data = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
    setMessages(data);
  };

  const fetchApplications = async () => {
    const querySnapshot = await getDocs(collection(db, "applications"));
    const data = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
    setApplications(data);
  };

  const handleDelete = async (id) => {
    await deleteDoc(doc(db, "contacts", id));
    fetchMessages();
  };

  useEffect(() => {
    if (activePage === "messages") {
      fetchMessages();
    }
    if (activePage === "dashboard") {
      fetchApplications();
      fetchMessages();
    }
  }, [activePage]);

  return (
    <div className="dashboard">

      {/* Sidebar */}
      <div className="sidebar">
        <h2 className="logo">⚡ Admin Panel</h2>

        <ul>
          <li
            className={activePage === "dashboard" ? "active" : ""}
            onClick={() => setActivePage("dashboard")}
          >
            📊 Dashboard
          </li>

          <li
            className={activePage === "messages" ? "active" : ""}
            onClick={() => setActivePage("messages")}
          >
            📩 Messages
          </li>

          <li
            className={activePage === "postJob" ? "active" : ""}
            onClick={() => setActivePage("postJob")}
          >
            💼 Post Job
          </li>

          <li
            className={activePage === "applications" ? "active" : ""}
            onClick={() => setActivePage("applications")}
          >
            📄 Applications
          </li>

          <li onClick={handleLogout} className="logout">
            🚪 Logout
          </li>
        </ul>
      </div>

      {/* Main Content */}
      <div className="main">

        <div className="topbar">
          <h2>
            {activePage === "dashboard" && "Dashboard Overview"}
            {activePage === "messages" && "User Messages"}
            {activePage === "postJob" && "Post New Job"}
            {activePage === "applications" && "Applicant Management"}
          </h2>
        </div>

        {/* Dashboard */}
        {activePage === "dashboard" && (
          <div className="cards">
            <div className="card">
              <h3>Total Users</h3>
              <p>120</p>
            </div>

            <div className="card">
              <h3>Total Messages</h3>
              <p>{messages.length}</p>
            </div>

            <div className="card">
              <h3>Total Applications</h3>
              <p>{applications.length}</p>
            </div>

            <div className="card">
              <h3>Revenue</h3>
              <p>₹ 25,000</p>
            </div>
          </div>
        )}

        {/* Messages */}
        {activePage === "messages" && (
          <div className="message-grid">
            {messages.length === 0 ? (
              <p className="no-message">No Messages Found</p>
            ) : (
              messages.map((msg) => (
                <div className="message-card" key={msg.id}>
                  <h3>{msg.name}</h3>
                  <p className="email">{msg.email}</p>
                  <p className="message">{msg.message}</p>

                  <button
                    className="delete-btn"
                    onClick={() => handleDelete(msg.id)}
                  >
                    Delete
                  </button>
                </div>
              ))
            )}
          </div>
        )}

        {/* Post Job */}
        {activePage === "postJob" && <AdminPostJob />}

        {/* Applications */}
        {activePage === "applications" && <AdminApplicants />}

      </div>
    </div>
  );
}

export default AdminDashboard;